export default {"src":"/_next/static/media/logo-poscodx.38f85f16.svg","height":120,"width":124,"blurWidth":0,"blurHeight":0};